import { createAsyncThunk } from '@reduxjs/toolkit';
import { TELERADIOLOGY_ADD_API_URL } from '@custom/constant';
import { TeleraidologyAddArgs } from '@custom/Utils/constants/interfaces';

// Async thunk to add a teleradiology customer
export const addTeleraidologyCustomer = createAsyncThunk(
  'customer/addTeleraidologyCustomer',
  async (customerData: TeleraidologyAddArgs, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(TELERADIOLOGY_ADD_API_URL, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(customerData),
      });

      if (!response.ok) {
        throw new Error('Failed to add teleraidology customer');
      }

      return await response.json(); // Return the response data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);

export default addTeleraidologyCustomer;
